import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { selectTranslations } from '../App/slice/selectors';

interface HeaderStepProps {}

const HeaderStep: React.FC<HeaderStepProps> = props => {
  const translations = useSelector(selectTranslations);
  const history = useHistory();
  const [steps] = useState([
    {
      step: '01',
      title: 'Lựa chọn combo',
      urlCurrent: ['/holiday'],
    },
    {
      step: '02',
      title: 'Thông tin hành khách',
      urlCurrent: [
        '/holiday/infoCustomer',
        '/holiday/payment-information',
        '/holiday/passenger-info',
      ],
    },
    {
      step: '03',
      title: 'Thanh toán',
      urlCurrent: ['/holiday/checkout'],
    },
  ]);
  const currentPath = history.location.pathname;

  const allUrls = steps.flatMap((step, stepIndex) =>
    step.urlCurrent.map(url => ({
      url,
      stepIndex,
    })),
  );
  const matched = allUrls
    .filter(item => currentPath.startsWith(item.url))
    .sort((a, b) => b.url.length - a.url.length)[0];
  const currentStepIndex = matched ? matched.stepIndex : 0;
  return (
    <StepContainerWrapper>
      {steps.map((step, index) => {
        const isActive = index === currentStepIndex;
        const isCompleted = index < currentStepIndex;
        return (
          <StepWrapper key={step.step}>
            <div className="d-flex gap-2">
              <div
                className={`boxNumber ${
                  isActive || isCompleted ? 'active' : ''
                }`}
              >
                {isCompleted ? (
                  <i className="fa-solid fa-check"></i>
                ) : (
                  step.step
                )}
              </div>
              <div className="title">{step.title}</div>
            </div>
            {steps.indexOf(step) < steps.length - 1 && <div className="line" />}
          </StepWrapper>
        );
      })}
    </StepContainerWrapper>
  );
};

export default HeaderStep;
const StepContainerWrapper = styled.div`
  min-height: 44px;
  margin-bottom: 10px;
  display: flex;
  justify-content: center;
  @media (max-width: 768px) {
    justify-content: space-between;
    width: 100%;
  }
`;
const StepWrapper = styled.div`
  display: flex;
  align-items: center;
  .line {
    width: 15px;
    background-color: #c2c2c2;
    height: 1px;
    margin: 0 10px;
  }
  .boxNumber {
    width: 24px;
    height: 24px;
    min-width: 24px;
    border-radius: 50%;
    background-color: #d9d9d9;
    color: #262626;
    font-size: 11px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 600;
    position: relative;
    z-index: 1;
  }
  .boxNumber.active {
    background: var(--color-gradient);
    color: #fff;
  }
  .title {
    font-size: 14px;
    font-weight: 600;
  }
  @media (max-width: 768px) {
    flex: 1;
    flex-direction: column;
    position: relative;
    .d-flex {
      flex-direction: column;
      align-items: center;
      gap: 4px !important;
    }
    .title {
      font-size: 11px;
      text-align: center;
      line-height: 1.3;
    }
    .line {
      position: absolute;
      top: 12px;
      left: 65%;
      width: calc(100% - 60px);
      height: 1px;
      background-color: #c2c2c2;
      z-index: 0;
    }
  }
`;
